import {deleteChat, editChatName, toggleChatFavorite} from "../../../../Utils/db/chatHistory/chatMetadataUtils.ts";
import React from "react";
import {loadChat} from "../../../../Utils/db/chatHistory/loadChat.ts";

export const handleEditClick = (
    event: React.MouseEvent,
    chatId: string,
    setEditingChatId: any,
    setActiveDropdownId: any
) => {
    event.stopPropagation();
    setEditingChatId(chatId);
    setActiveDropdownId(null);
};

export const handleSaveEditClick = (
    event: React.MouseEvent | React.KeyboardEvent,
    chatId: string,
    editedChatName: string,
    updateChatHistory: any,
    user: any,
    setEditingChatId: any
) => {
    event.stopPropagation();
    setEditingChatId(null);
    editChatName(editedChatName, updateChatHistory, chatId, user);
};

export const handleCancelEditClick = (
    event: React.MouseEvent,
    chat: any,
    setEditedChatName: (name: string) => void,
    setEditingChatId: any,
    setShowDeleteConfirmation: (show: boolean) => void
) => {
    event.stopPropagation();
    setEditedChatName(chat.name);
    setEditingChatId(null);
    setShowDeleteConfirmation(false);
};

export const handleSaveDeleteClick = (event: React.MouseEvent, chatId: string, focusedChatId: any, setActiveDropdownId: any, setShowDeleteConfirmation: (show: boolean) => void, updateChatHistory: any, user: any, resetStateHelper: any) => {
    event.stopPropagation();
    setActiveDropdownId(null);
    deleteChat(user, chatId, focusedChatId, updateChatHistory, resetStateHelper);
    setShowDeleteConfirmation(false);
};

export const handleCancelDeleteClick = (
    event: React.MouseEvent,
    setActiveDropdownId: any,
    setShowDeleteConfirmation: (show: boolean) => void
) => {
    event.stopPropagation();
    setActiveDropdownId(null);
    setShowDeleteConfirmation(false);
};

export const handleDropdownToggleNoProp = (
    event: React.MouseEvent,
    onDropdownToggle: (chatId: string) => void,
    chat: any
) => {
    event.stopPropagation();
    onDropdownToggle(chat.id);
};

export const handleChatClick = (setEditingChatId: any, chat: any, messagesRef: any, currentMessageRef: any, messagesSequenceRef: any, setDynamicStateObj: any, setMessages: any, updateImportantMessageIds: any, user: any, resetStateHelper: any) => {
    setEditingChatId(null);
    loadChat(user, chat.id, messagesSequenceRef, currentMessageRef, messagesRef, setMessages, updateImportantMessageIds, setDynamicStateObj, resetStateHelper);
};

export const handleDeleteClick = (
    event: React.MouseEvent,
    setShowDeleteConfirmation: (show: boolean) => void
) => {
    event.stopPropagation();
    setShowDeleteConfirmation(true);
};

export const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    setEditedChatName: (name: string) => void
) => {
    event.stopPropagation();
    setEditedChatName(event.target.value);
};

export const handleFavoriteClick = (
    event: React.MouseEvent,
    chatId: string,
    chatHistory: any[],
    updateChatHistory: any,
    user: any,
    setActiveDropdownId: any
) => {
    event.stopPropagation();
    setActiveDropdownId(null);

    // Find current chat and toggle favorite status
    const currentChat = chatHistory.find((chat: any) => chat.id === chatId);
    const newFavoriteStatus = !(currentChat?.isFavorite || false);

    toggleChatFavorite(user, chatId, newFavoriteStatus, updateChatHistory);
};
